import { render, staticRenderFns } from "./admissionRosterCopyDetaile.vue?vue&type=template&id=64ec1939&scoped=true&"
import script from "./admissionRosterCopyDetaile.vue?vue&type=script&lang=js&"
export * from "./admissionRosterCopyDetaile.vue?vue&type=script&lang=js&"
import style0 from "./admissionRosterCopyDetaile.vue?vue&type=style&index=0&id=64ec1939&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec1939",
  null
  
)

export default component.exports